import {useContext} from 'react'
import {useNavigate} from 'react-router-dom'
import {StoreFrontScriptManagerContext} from '../../context'
import Search from '../../../../components/Search'

const ScriptsHeader = () => {
  const {onSearch, hasWritePermission} = useContext(StoreFrontScriptManagerContext)
  const navigate = useNavigate()

  const handleCreateClick = () => {
    navigate('/storefronts/script-manager/new')
  }

  return (
    <div className='d-flex justify-content-between mb-10'>
      <Search
        onSearch={(searchTerm: string) => {
          onSearch && onSearch(searchTerm)
        }}
      />
      {hasWritePermission && (
        <div className='text-end'>
          <button onClick={handleCreateClick} className='btn btn-primary'>
            <i className='bi bi-plus-lg'></i>
            Create a Script
          </button>
        </div>
      )}
    </div>
  )
}

export default ScriptsHeader
